import * as request from 'request';
import * as nodemailer from 'nodemailer';
import 'dotenv/config';

export async function sendTextLocalSMS(mobileNo, MSG_TEMPLATE, TEMPLATE_ID) {
    let options = {
        user: process.env.BulkSMS_USER,
        password: process.env.BlkSMS_PWD,
        mobile: mobileNo,
		message:MSG_TEMPLATE,
		sender: process.env.BlkSMS_SENDER,
        type:3,
		template_id:TEMPLATE_ID,
    };
    return new Promise((resolve, reject) => {
        request.post({ url: process.env.BulkSMS_HOST, form: options }, (error: any, response: any, body: any) => {
			if (error) {
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}

export async function sendMailInfo(receiver: any, message: any, anothermsg: any) {
	let transporter = nodemailer.createTransport({
		host: 'smtp.gmail.com',
		port: 465,
		secure: true,
		auth: {
			user: 'nriteluguidol@gmail.com',
			pass: 'Warangal@1975'
        },
        tls: {
            // do not fail on invalid certs
            rejectUnauthorized: false
        },
	});

	let mailOptions = {
		from: 'nriteluguidol@gmail.com',
		to: 'info@abrproductions.com',
		subject: 'From ABR application',
		text: '',
		html: `${message}`
    };
    
    let mailOptions1 = {
		from: 'nriteluguidol@gmail.com',
		to: receiver,
		subject: 'From ABR application',
		text: '',
		html: `${anothermsg}`
	};

	/* transporter.sendMail(mailOptions, (err: any, su: { messageId: any; }) => {
		if (err) console.log(err, 'thisis  errror in mail');
		else {
			console.log(su.messageId);
		}
    }); */
    
    transporter.sendMail(mailOptions1, (err: any, su: { messageId: any; }) => {
		if (err) console.log(err, 'thisis  errror in mail');
		else {
			console.log(su.messageId);
		}
	});
}

export async function sendFCMNotifications(MSG_TEMPLATE) {
	let headersRequest = {
		"Content-Type": "application/json", // afaik this one is not needed
		"Authorization": "key="+process.env.FCM_HEADER_KEY,
	};
	var options = { method: 'POST',
  		url: 'https://fcm.googleapis.com/fcm/send',
  		headers: 
   		{ 
     	'content-type': 'application/json',
     	authorization: 'key='+process.env.FCM_HEADER_KEY
		},
  		body: MSG_TEMPLATE,
  		json: true 
	};
    return new Promise((resolve, reject) => {
        request(options, (error: any, response: any, body: any) => {
			console.log('res',response);
			//console.log('body',body)
			//console.log('hed',headersRequest)
			//console.log('input',MSG_TEMPLATE)
			if (error) {
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}


